<div class="canvas-container">
    <canvas id="canvas" #canvas width="750" height="750"></canvas>
</div>
